import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import authenService from "services/authenService";

export const useSaveFilter = (onSuccess, onError) => {
  const queryClient = useQueryClient();
  const mutate1 = useMutation(authenService.saveMyFilter, {
    retry: 0,
    onSuccess: data => {
      // ✅ refetch the comments list for our blog post
      queryClient.invalidateQueries("screenFilter");
      if (typeof onSuccess === "function") {
        //   onSuccess({ ...data, appCodes });
      }
    },
    onError: error => {
      if (typeof onError === "function") {
        //   onError(errorResponse);
      }
    },
    onMutate: newItem => {
      queryClient.cancelQueries("screenFilter");
      const previousTodos = queryClient.getQueryData(["screenFilter"]);
      const dataChange = {
        [newItem.screenFilterCode]: {
          filterQuery: {
            ...newItem.columnFilter,
          },
          filterValue: {
            ...newItem.columnFilterValue,
          },
          columnsVisible: {
            ...newItem.columnsVisibleInvoice,
          },
        },
      };
      queryClient.setQueryData(["screenFilter"], {
        ...previousTodos,
        ...dataChange,
      });
      return () => queryClient.setQueryData(["screenFilter"], previousTodos);
    },
  });
  return {
    ...mutate1,
    mutate: ({
      screenFilterCode,
      columnFilter = null,
      columnFilterValue = null,
      columnsVisibleInvoice = null,
      fieldRemoveFilter = null,
      filterQueryAdd = null,
      filterValueAdd = null,
      isClearFilter = false,
    }) => {
      const screenData = queryClient.getQueryData(["screenFilter"]);
      let param;
      const currentScreen = screenData?.[screenFilterCode];
      // Clear data filter
      if (isClearFilter) {
        // lưu filter
        if (currentScreen) {
          param = {
            screenFilterCode,
            columnFilter: {},
            columnFilterValue: {},
            screenData,
            columnsVisibleInvoice: currentScreen?.columnsVisible,
          };
        } else {
          param = {
            screenFilterCode,
            columnFilter: {},
            columnFilterValue: {},
            screenData,
            columnsVisibleInvoice: null,
          };
        }
        mutate1.mutate(param);
        return;
      }
      // Lưu cột ẩn/hiện
      if (columnsVisibleInvoice) {
        if (currentScreen) {
          // Bỏ lưu filter những cột ẩn
          if (fieldRemoveFilter) {
            const object = currentScreen?.filterQuery;
            for (const key in object) {
              if (key.indexOf(fieldRemoveFilter) > -1) {
                delete object[key];
              }
            }
            delete currentScreen?.filterValue[fieldRemoveFilter];
          }
          // Lưu filter lại những cột ẩn trước đó
          if (filterQueryAdd) {
            currentScreen.filterQuery = {
              ...currentScreen.filterQuery,
              ...filterQueryAdd,
            };
          }
          if (filterValueAdd) {
            currentScreen.filterValue = {
              ...currentScreen.filterValue,
              ...filterValueAdd,
            };
          }
          //
          param = {
            screenFilterCode,
            columnFilter: currentScreen?.filterQuery,
            columnFilterValue: currentScreen?.filterValue,
            screenData,
            columnsVisibleInvoice: columnsVisibleInvoice,
          };
        } else {
          param = {
            screenFilterCode,
            columnFilter: null,
            columnFilterValue: null,
            screenData,
            columnsVisibleInvoice,
          };
        }
      } else {
        // lưu filter
        if (currentScreen) {
          param = {
            screenFilterCode,
            columnFilter,
            columnFilterValue,
            screenData,
            columnsVisibleInvoice: currentScreen?.columnsVisible,
          };
        } else {
          param = {
            screenFilterCode,
            columnFilter,
            columnFilterValue,
            screenData,
            columnsVisibleInvoice: null,
          };
        }
      }
      mutate1.mutate(param);
    },
  };
};

export const useGetFilter = (screenFilterCode, onSuccess, onError) => {
  return useQuery(["screenFilter"], () => authenService.getMyFilter(), {
    enabled: false,
    retry: 1,
    cacheTime: 0,
    onSuccess,
    select: response => {
      return response?.[screenFilterCode] || null;
    },
  });
};
